import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type HelpDocsEvents = 'PAGE_VIEW' | 'TOGGLE' | 'OPEN_IN_NEW_TAB' | 'HELP_MENU_CLOSE';

export const helpDocs: Record<HelpDocsEvents, MixpanelEvent> = {
  PAGE_VIEW: {
    eventDescription: 'In-app Help Docs Page View',
    eventKey: 'in-app-help-docs-page-view',
    eventSource: EventSource.PAGE_VIEW,
    interactionType: InteractionType.PAGE_VIEW
  },
  TOGGLE: {
    eventDescription: 'In-app Help Docs Toggle',
    eventKey: 'in-app-help-docs-toggle',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.APP_TOOLBAR_BUTTON
  },
  OPEN_IN_NEW_TAB: {
    eventDescription: 'In-app Help Docs Open In New Tab',
    eventKey: 'in-app-help-docs-open-in-new-tab',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.OPEN_IN_NEW_TAB_BUTTON
  },
  HELP_MENU_CLOSE: {
    eventDescription: 'Help Menu Close',
    eventKey: 'help-menu-close',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.APP_TOOLBAR_BUTTON
  }
} as const;

export type HelpDocsOrigin = {
  // The page within BP on which the user decided to open the in-app help docs
  appPage: string;
};

export type HelpDocsPageViewDetails = HelpDocsOrigin & {
  from: string;
  to: string;
};

export type HelpDocsToggleDetails = HelpDocsOrigin & {
  toggleAction: 'open' | 'close';
  page: string;
};

export type HelpDocsOpenInNewTabDetails = HelpDocsOrigin & {
  page: string;
};
